import { HttpClient } from '@wix/sdk-types';
import {
  DeliverableItem,
  GetDeliverySolutionsOptions,
  GetDeliverySolutionsResponse,
  GetDeliverySolutionsResponseNonNullableFields,
  getDeliverySolutions as universalGetDeliverySolutions,
} from './gateways-ecom-v1-delivery-rates-gateway-delivery-solutions.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/ecom' };

export function getDeliverySolutions(
  httpClient: HttpClient
): GetDeliverySolutionsSignature {
  return (
    lineItems: DeliverableItem[],
    options?: GetDeliverySolutionsOptions
  ) =>
    universalGetDeliverySolutions(
      lineItems,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface GetDeliverySolutionsSignature {
  /**
   * Get Delivery Solutions for the given line items from all relevant delivery carriers
   * @param - list of items to delivery that each of them points to delivery profile and delivery rule.
   * @returns Each delivery option has a list of items that can be delivered by it - the chosen one
   * on Errors throw a business error from TC to catch and trigger destination completion
   */
  (
    lineItems: DeliverableItem[],
    options?: GetDeliverySolutionsOptions | undefined
  ): Promise<
    GetDeliverySolutionsResponse & GetDeliverySolutionsResponseNonNullableFields
  >;
}

export {
  AdditionalCharge,
  Address,
  AddressLocation,
  AddressStreetOneOf,
  ApplicableLineItems,
  ApplicationError,
  Carrier,
  CatalogReference,
  ChargeType,
  DeliverableItem,
  DeliveryAllocation,
  DeliveryCarrierError,
  DeliveryCost,
  DeliveryLogistics,
  DeliveryRatesGateway,
  DeliverySolution,
  DeliveryTimeSlot,
  Details,
  DetailsKindOneOf,
  ExternalReference,
  FieldViolation,
  FullAddressContactDetails,
  GetDeliverySolutionsOptions,
  GetDeliverySolutionsRequest,
  GetDeliverySolutionsResponse,
  GetDeliverySolutionsResponseNonNullableFields,
  PhysicalProperties,
  PickupDetails,
  PickupMethod,
  Region,
  RuleType,
  StreetAddress,
  Subdivision,
  SubdivisionType,
  SystemError,
  UserPreference,
  ValidationError,
  VatId,
  VatType,
  WeightUnit,
} from './gateways-ecom-v1-delivery-rates-gateway-delivery-solutions.universal.js';
